<template>
  <div class="snack-catering">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner">
      <div class="bg"></div>
      <div class="center">
        <h1>{{ $t("message.snacks.banner.title") }}</h1>
        <p>{{ $t("message.snacks.banner.subTitle") }}</p>
        <el-button type="success">
          <template v-if="this.$i18n.locale === 'zh'">
            <router-link :to="{ path: '/menu/', params: { lang: this.$i18n.locale } }">到會預定</router-link>
          </template>
          <template v-else>
            <router-link :to="{ path: '/en/menu/', params: { lang: this.$i18n.locale } }">到會預定</router-link>
          </template>
        </el-button>
      </div>
    </div>
    <!-- 内容 -->
    <div class="activity-contanier">
      <div class="activity-main">
        <Title :title="$t('message.snacks.context.h2TitleOne')"></Title>
        <Content :content="$t('message.snacks.context.pContentOneFirst')"></Content>
        <Content :content="$t('message.snacks.context.pContentOneSecond')"></Content>
        <Content :content="$t('message.snacks.context.pContentOneThird')"></Content>
      </div>
    </div>
    <div class="faq-contanier">
      <div class="faq-main">
        <Title :title="$t('message.snacks.aboutSnacksTitle')"></Title>
        <div class="feq-content">
          <div class="about-food-main">
            <div v-for="item in 3" :key="item" style="margin-left:10px">
              <h3 style="color: #000">{{ $t(`message.snacks.aboutSnacks.faq${item}`) }}</h3>
              <div style="margin-left:10px" class="feq-content-text">
                {{ $t(`message.snacks.aboutSnacks.content${item}`) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
  </div>
</template>

<script>
import header from "../components/header";
import Title from './common/title.vue'
import Content from './common/content.vue'

export default {
  name: "caterers",
  data() {
    return {};
  },
  components: {
    "v-header": header,
    Title,
    Content
  }
};
</script>
<style lang="less" scoped>
.activity-contanier {
  background-image: url("../assets/images/bodybg.jpg");
  background-size: 100% 100%;

  .activity-main {
    width: 70%;
    padding: 3% 2%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .activity-content-main {
      display: flex;
      justify-content: space-around;
      @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .activity-item ~ .activity-item {
        margin-left: 30px;
        @media (max-width: 768px) {
          margin-left: 0px;
        }
      }

      .activity-item {
        text-align: center;
        flex: 0 0 30%;
        @media (max-width: 768px) {
          flex: 0 0 48%;
        }
        @media (max-width: 480px) {
          flex: 0 0 100%;
          display: flex;
          margin-bottom: 3%;
          text-align: left;
        }

        .activity-item-img {
          .item-img {
            width: 100%;
            height: 100%;
          }

          @media (max-width: 480px) {
            flex: 0 0 48%;
          }
        }

        .activity-item-content, .activity-item-span {
          margin: 20px;
        }

        .activity-item-content {
          font-size: 1.2vw;
          font-weight: 550;
        }

        .activity-item-span {
          font-size: 13px;
          color: #919599;
          font-weight: 350;
        }

        .item-button {
          @media (max-width: 480px) {
            margin: 0 20px;
          }
        }
      }
    }
  }
}
.faq-contanier {
  .faq-main {
    width: 70%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .feq-content {
      margin: 0 0 3%;
      font-size: .825rem;
      color: #919599;

      .feq-content-text {
        margin-bottom: 3%;
      }
    }

  }
}
.center {
  width: 75%;
  margin: auto;
}

.snack-catering .center a {
  color: white;
  text-decoration: none;
}

/* 广告 */
.banner {
  position: relative;
  width: 100%;
  height: 450px;
  background: url("../assets/images/equiry.png") no-repeat;
  background-size: 100% 100%;
  margin: 100px 0 0 0;
}

.banner h1,
.banner p {
  text-align: center;
  color: white;
}

.banner h1 {
  font-weight: bold;
  font-size: 50px;
}

.banner p {
  margin: 1% 0;
  font-size: 15px;
}

.banner .center {
  width: 80%;
  height: 40%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}

.banner .banner-call1 {
  font-weight: 200;
  color: #eb6410;
  letter-spacing: 0;
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}

@media (max-width: 820px) {
  .banner h1 {
    font-size: 25px;
  }

  .banner {
    height: 300px;
  }
}
</style>
<style>
.snack-catering .banner .el-button.el-button--success {
  display: block;
  width: 20rem;
  margin: 2% auto 0 auto;
  background: #eb6410;
  border: 1px solid #eb6410;
}

.snack-catering .banner .el-dialog {
  margin-top: 12vh !important;
}

.snack-catering .banner .el-dialog__body {
  padding: 0 33px 0 0 !important;
}

.snack-catering .el-scrollbar__view.el-time-spinner__list li,
.el-scrollbar__view.el-select-dropdown__list li {
  display: block;
}
</style>
